<template>
  <div>
    <slot/>
  </div>
</template>

<script setup>
import { onMounted } from "vue"

onMounted(() => {
  $("#W2013TIQ").dataTable({
    bStateSave: false,
    iDisplayLength: 200,
    oLanguage: {
      sSearch: "Filter: ",
      sProcessing: "Loading the index . . .",
    },
    bProcessing: true,
    aoColumnDefs: [
      { asSorting: ["asc", "desc"], aTargets: ["_all"] },
    ],
  })
})
</script>
